export default __webpack_public_path__ + "static/Arrow_top-e97bfe8857f9366e6a053b5d21d5645d.png";